import { PgFormField } from "../Shared/Types"

export interface GameFormState {
	id: number,
	title: PgFormField<string | undefined>,
	description?: string,
	boxArtUrl?: string,
	availableConsoles?: string[],
	releaseDate?: PgFormField<string | undefined>
}

export type GameFormAction = GameFormStringAction | GameFormFieldAction | GameFormStrArrAction;

export interface GameFormStringAction {
	type: Exclude<GameFormActionType, GameFormActionType.SetReleaseDate | GameFormActionType.SetTitle | GameFormActionType.SetAvailableConsoles>,
	payload: string
}

export interface GameFormFieldAction {
	type: GameFormActionType.SetReleaseDate | GameFormActionType.SetTitle, 
	payload: Partial<PgFormField<string>>
}

export interface GameFormStrArrAction {
	type: GameFormActionType.SetAvailableConsoles,
	payload: string[]
}

export enum GameFormActionType {
	SetTitle,
	SetDescription,
	SetAvailableConsoles,
	SetReleaseDate,
	SetBoxArtUrl
}

export enum GameSortOptions {
	Alphabetical = "Alphabetical",
	MostPopular = "Most Popular",
	Recent = "Recently Added"	
}